import config from '../../../config';
import axiosAdapter from '../../../utils/Adapters';

const captchaHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Api-Key': config.xApiKey,
};

/**
 * Get client country/region code
 * @returns object => "{"countrySid":86,"countrySymbol":"HKG"}"
 */
export const getLocationCode = async () => {
  const url = config.locationServiceEndPoint;
  try {
    const response = await axiosAdapter({ url });
    return response?.data || {};
  } catch (error) {
    console.error('Error fetcching location service:', error);
    return {};
  }

  // let result = "";
  // await axiosAdapter({ url }).then((response) => {
  //     if(response.data) {
  //         result = response.data;
  //     } else {
  //         console.warn("Invalid location service response data:", response);
  //     }
  // })
  // .catch((error) => {
  //     console.error("Error fetcching location service:", error)
  // })
  // return result;
};

export const getLocationIP = async () => {
  const url = config.captchaLocationPath;

  try {
    const response = await axiosAdapter({ url });
    return response?.data || {};
  } catch (error) {
    console.error('Error fetcching location IP:', error);
    return {};
  }

  // let result = {};
  // await axiosAdapter({ url }).then((response) => {
  //     if(response.data) {
  //         result = response.data;
  //     } else {
  //         console.warn("Invalid location IP response data:", response);
  //     }
  // })
  // .catch((error) => {
  //     console.error("Error fetcching location IP:", error)
  // })
  // return result;
};

export const verifyTencent = async (locationIp, ticket, randstr) => {
  const url = config.tencentCaptchaPath;
  const body = {
    ip: locationIp.ip,
    ticket: ticket,
    randstr: randstr,
  };
  const option = {
    url: url,
    data: body,
    method: 'post',
    headers: captchaHeaders,
  };

  try {
    const response = await axiosAdapter(option);
    return response?.data?.success || false;
  } catch (error) {
    console.error('@@verifyTencent error==>:', error);
    return false;
  }

  // let status = false;
  // await axiosAdapter( option ).then((response) => {
  //     if(response.data) {
  //         console.log("@@verifyTencent==>",response.data);
  //         status = response.data.success;
  //     } else {
  //         console.warn("@@Invalid verifyTencent reponse data==>:", response);
  //     }
  // })
  // .catch((error) => {
  //     console.error("@@verifyTencent error==>:", error);
  // })
  // return status;
};

export const verifyGoogle = async (ticket) => {
  const url = config.googleCaptchaPath;
  const body = {
    ip: '0.0.0.0',
    ticket: ticket,
  };
  const option = {
    url: url,
    data: body,
    method: 'post',
    headers: captchaHeaders,
  };

  try {
    const response = await axiosAdapter(option);
    return response?.data?.success || false;
  } catch (error) {
    console.error('@@verifyGoogle error==>:', error);
    return false;
  }

  // let status = false;
  // await axiosAdapter( option ).then((response) => {
  //     if(response.data) {
  //         console.log("@@verifyGoogle==>",response.data);
  //         status = response.data.success;
  //     } else {
  //         console.warn("@@Invalid verifyGoogle reponse data==>", response);
  //     }
  // })
  // .catch((error) => {
  //     console.error("@@verifyGoogle error==>:", error);
  // })
  // return status
};

export const sendSubscription = async (params) => {
  // submit
  const option = {
    url: config.epcPath,
    data: params,
    method: 'post',
  };

  try {
    const response = await axiosAdapter(option);
    return response || {};
  } catch (error) {
    console.error('@@Submit Subscription error==>:', error);
    return {};
  }

  // let result;
  // await axiosAdapter(option).then((response) => {
  //     result =  response;
  // });
  // return result;
};
